import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class ReceiptService {
  constructor(private http: HttpClientService) {}

  public getAllReceipts({ process = undefined, search = "", page = undefined, page_size = undefined }) {
    const options = {
      params: {
        process,
        search,
        page,
        page_size,
      },
    };
    return this.http.get("/api/receipt", options).pipe(tap((_) => console.log("ReceiptService.getAllReceipts: Ok.")));
  }

  public recalculateInvestor(id: number) {
    return this.http
      .post(`/api/receipt/${id}/recalculate_investor_values`, {})
      .pipe(tap((_) => console.log("ReceiptService.recalculate_investor: Ok.")));
  }

  public forwardInformation(id: number) {
    return this.http
      .post(`/api/receipt/${id}/forward_information`, {})
      .pipe(tap((_) => console.log("ReceiptService.forwardInformation: Ok.")));
  }

  public detailsPendings(id: number) {
    return this.http
      .post(`/api/receipt/${id}/details_pendings`, {})
      .pipe(tap((_) => console.log("ReceiptService.detailsPendings: Ok.")));
  }

  public updateAmountReceiptToCxc(id: number, amount?: number) {
    return this.http
      .post(`/api/receipt/${id}/update_amount_to_cxc`, { amount })
      .pipe(tap((_) => console.log("ReceiptService.updateAmountReceiptToCxc: Ok.")));
  }

  public addManualReceipt(receipt: {
    amount: number;
    process: string;
    date_deposit: Date;
    realized_at: Date;
    payment_method: string;
    send_to_cxc: boolean;
  }) {
    return this.http
      .post(`/api/receipt/manual_receipt`, { receipt })
      .pipe(tap((_) => console.log("ReceiptService.addManualReceipt: Ok.")));
  }

  public updateManualReceipt(
    id: number,
    receipt: {
      amount: number;
      process: string;
      date_deposit: Date;
      realized_at: Date;
      payment_method: string;
      send_to_cxc: boolean;
    }
  ) {
    return this.http
      .put(`/api/receipt/${id}/manual_receipt`, { receipt })
      .pipe(tap((_) => console.log("ReceiptService.updateManualReceipt: Ok.")));
  }

  public sendComplement(id: number, amount: number) {
    return this.http
      .post(`/api/receipt/${id}/send_complement`, { amount })
      .pipe(tap((_) => console.log("ReceiptService.sendComplement: Ok.")));
  }
}
